import { Flex, Text, TextInput } from "@jsq/ds/core";
import { Drawer } from "./Drawer";
import { useDdqDrawer } from "./Drawer/useDdqDrawer";
import { Grid } from "./Grid";
import * as styles from "./styles_vanilla.css";
import { SummaryFilterCards } from "./SummaryFilterCards";
import { useDdqProdOpsQueue } from "./useDdqProdOpsQueue";
import { useDdqQueueFilters } from "./useDdqQueueFilters";

export const DDQueue = () => {
  const filters = useDdqQueueFilters();
  const queue = useDdqProdOpsQueue(filters.variables);
  const { selectedRow, isOpen, onRowClicked, onClose, onCloseAnimationComplete } = useDdqDrawer(
    queue.rows,
  );

  return (
    <Flex className={styles.container} flexDirection="column">
      <Flex className={styles.header} justifyContent="space-between" alignItems="center">
        <Text variant="regular-xl">DDQ intake</Text>
      </Flex>
      <SummaryFilterCards
        cardWorkflowTypes={filters.cardWorkflowTypes}
        onToggleWorkflowType={filters.toggleWorkflowTypeCard}
        cardStatuses={filters.cardStatuses}
        onToggleStatus={filters.toggleStatusCard}
      />
      <Flex className={styles.searchRow}>
        <TextInput
          value={filters.search}
          onChange={(event) => filters.setSearch(event.target.value)}
          placeholder="Search by GP name or DDQ title"
          icon="search"
          isClearable
          onClearValue={() => filters.setSearch("")}
          data-testid="ddq-prod-ops-queue-search"
        />
      </Flex>
      <Flex className={styles.tableContainer} flexDirection="column">
        <Grid queue={queue} onRowClicked={onRowClicked} filters={filters} />
      </Flex>
      {/* Keyed so a second request opens on Tasks rather than the previous row's tab. */}
      <Drawer
        key={selectedRow?.id}
        row={selectedRow}
        isOpen={isOpen}
        onClose={onClose}
        onCloseAnimationComplete={onCloseAnimationComplete}
      />
    </Flex>
  );
};
